/**
 * The item's "User" field (system field id `custody`): its custodian, else the customer of the
 * booking it is currently checked out on. Shared by the overview column and `ItemInfo`.
 */
export const getItemUser = <TCustomer>(item: {
	custody?: TCustomer | null;
	order?: { customer?: TCustomer | null } | null;
}): TCustomer | undefined => item.custody ?? item.order?.customer ?? undefined;
